var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47,
    stroke: "#A03BCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8476 53.6654C38.0172 52.9099 37.7089 51.8308 37.1693 51.2912L33.423 47.5449C32.2514 46.3733 31.7889 45.1245 32.128 44.0454C32.4826 42.9662 33.5772 42.2262 35.2114 41.9487L40.0214 41.147C40.7151 41.0237 41.563 40.407 41.8868 39.7749L44.5385 34.4562C45.3093 32.9299 46.3576 32.082 47.4985 32.082C48.6393 32.082 49.6876 32.9299 50.4585 34.4562L53.1101 39.7749C53.3105 40.1758 53.7268 40.5612 54.1739 40.8233L37.5701 57.427C37.3543 57.6429 36.9843 57.4424 37.046 57.1341L37.8476 53.6654Z",
    fill: "#A03BCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8309 51.2973C57.2759 51.8523 56.9675 52.9161 57.1525 53.6715L58.2163 58.3119C58.6634 60.239 58.3859 61.6881 57.43 62.3819C57.0446 62.6594 56.5821 62.7981 56.0425 62.7981C55.2563 62.7981 54.3313 62.5052 53.3138 61.904L48.7967 59.2215C48.0875 58.8052 46.9159 58.8052 46.2067 59.2215L41.6896 61.904C39.9784 62.9061 38.5138 63.0756 37.5734 62.3819C37.2188 62.1198 36.9567 61.7652 36.7871 61.3027L55.5338 42.5561C56.2429 41.8469 57.245 41.5231 58.2163 41.6927L59.7734 41.9548C61.4075 42.2323 62.5021 42.9723 62.8567 44.0515C63.1959 45.1306 62.7334 46.3794 61.5617 47.5511L57.8309 51.2973Z",
    fill: "#A03BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPurple);
export default __webpack_public_path__ + "static/media/star-purple.d47fa66279441092c5b46971621bf435.svg";
export { ForwardRef as ReactComponent };